export const wizardIdle = new Image();
wizardIdle.src = "./assets/characterSprites/Evil_Wizard_2/Idle.png";
wizardIdle.width = 2000/8
// wizardIdle.height = wizardIdle.height/1
wizardIdle.yOffset = -25
wizardIdle.xOffset = -40
wizardIdle.cycleLoop = [0, 1, 2, 3, 4, 5, 6, 7];
